import { ConvertDtokToMagicLinkResponse } from '@sxm-de/dev-kits/microservices-sdk/types';
import { convertDtokToMagicLink } from '../helpers/convert-dtok-to-magic-link';

export type ConvertDtokToMagicLinkCanadaFn = (payload: {
    token: string;
}) => Promise<ConvertDtokToMagicLinkResponse>;

export function initConvertDtokToMagicLinkCanadaFn({
    baseUrl,
}: {
    baseUrl: string;
}): ConvertDtokToMagicLinkCanadaFn {
    return async ({ token }) => {
        return await convertDtokToMagicLink({
            baseUrl,
            token,
        });
    };
}
